// extracted by mini-css-extract-plugin
export default {"diagramCard":"styles_diagramCard__r4t-Q","diagramCardSubHeader":"styles_diagramCardSubHeader__OidjT","files":"styles_files__VZFqZ"};